export default __webpack_public_path__ + "static/home-specialty-group-6afbe6f8f5c2c6ff2af15ad8e42b96b5.jpg";